module.exports = __webpack_public_path__ + "img/success_black@2x.3b473b14.png";